import { StrictMode, useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { MsalProvider } from '@azure/msal-react';
import { ensureMsalInitialized, msalInstance } from './auth/msal';
import { AuthRolesProvider } from './auth/AuthContext';
import { AppRoutes } from './routes/AppRoutes';
import { config } from './config';
import './styles.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

function Root() {
  const [ready, setReady] = useState(config.devAuth);

  useEffect(() => {
    if (config.devAuth) return;
    void ensureMsalInitialized().then(() => setReady(true));
  }, []);

  if (!ready) {
    return <div className="empty">Initializing authentication…</div>;
  }

  const tree = (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthRolesProvider>
          <AppRoutes />
        </AuthRolesProvider>
      </BrowserRouter>
    </QueryClientProvider>
  );

  if (config.devAuth) {
    return tree;
  }

  return <MsalProvider instance={msalInstance}>{tree}</MsalProvider>;
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Root />
  </StrictMode>,
);
